import { ROLE_STORAGE_KEY, roles, type AppRole } from './paths';

function normalizeRole(value: unknown): AppRole | null {
  if (value == null) return null;
  const raw =
    typeof value === 'string'
      ? value
      : (value as { title?: string; name?: string }).title ||
        (value as { name?: string }).name ||
        '';
  const token = String(raw).trim().toLowerCase();
  if (!token) return null;
  if (token.includes('mentor') || token.includes('owner')) return roles.MENTOR;
  if (token.includes('client') || token.includes('student') || token.includes('mentee')) {
    return roles.CLIENT;
  }
  if (token === roles.MENTOR || token === roles.CLIENT) return token;
  return null;
}

export function persistAppRole(role: AppRole | string) {
  const normalized = normalizeRole(role);
  if (normalized && normalized !== roles.NONE) {
    localStorage.setItem(ROLE_STORAGE_KEY, normalized);
  }
}

export function resolveAppRole(user?: any, storeRoles?: any): AppRole {
  if (!user) return roles.NONE;

  const stored = normalizeRole(localStorage.getItem(ROLE_STORAGE_KEY));
  const fromUser = normalizeRole(
    user.role || user.title || user.roles?.[0] || user.roleTitle,
  );
  const fromStore = Array.isArray(storeRoles)
    ? normalizeRole(storeRoles[0])
    : normalizeRole(storeRoles);

  return fromUser || stored || fromStore || roles.CLIENT;
}
